import Header from 'components/Header/header'
import { useAgency } from 'context/agency'
import React from 'react'
import { Outlet } from 'react-router-dom'

function AppLayout() {
  const { style } = useAgency()
  return (
    <div>
      <Header />
      <main className='w-full px-8'>
        <Outlet />
      </main>
    </div>
  )
}

export default AppLayout
